import styled from "styled-components";
import CompanyListItem from "./CompanyListItem";
import Checkbox from "../../../Common/Components/Checkbox";

const CompanyList: React.FC = (props) => {
  return (
    <Wrapper>
      <table>
        <thead>
          <tr>
            <td className="checkbox">
              <Checkbox />
            </td>
            <td className="h-name">Name</td>
            <td>Location</td>
            <td>Industry</td>
            <td></td>
            <td className="last-td">Engagement Score</td>
          </tr>
        </thead>
        <tbody>
          <CompanyListItem />
          <CompanyListItem />
        </tbody>
      </table>
    </Wrapper>
  );
};

export default CompanyList;

const Wrapper = styled.div`
  margin-bottom: 40px;
  position: relative;
  table {
    width: 100%;
    border: none;
    margin-bottom: 90px;
    thead {
      td {
        color: #5e7079;
        font-size: 18px;
        font-family: "robotomedium";
        font-weight: 500;
        &.h-name {
          padding-left: 75px;
        }
      }
    }
    tr {
      border-bottom: 1px solid #dddddd;
      td {
        padding: 9px 10px;
        &.checkbox {
          width: 10px;
          padding-right: 0 !important;
        }
        .profile-img {
          width: 54px;
          height: 54px;
          border-radius: 9px;
          float: left;
        }
        .profile {
          float: left;
          padding-left: 14px;
          text-align: left;
          padding-top: 10px;
          .designation {
            color: #27ce0a;
            font-size: 14px;
            font-family: "robotomedium";
            font-weight: 500;
          }
          .name {
            color: #000000;
            font-size: 20px;
            font-family: 'Roboto Slab', serif;
          }
        }
        .organization {
          display: block;
          width: 100%;
          color: #424b50;
          font-size: 18px;
          font-family: "robotomedium";
          font-weight: 500;
        }
        .industrie {
          display: block;
          width: 100%;
          font-size: 16px;
          font-family: "robotomedium";
          font-weight: 500;
          color: #5e7079;
        }
        .engagement {
          border-radius: 12px;
          background-color: #1971eb;
          color: #ffffff;
          font-size: 16px;
          font-family: "robotomedium";
          font-weight: 500;
          padding: 0px 10px;
          display: inline;
          float: right;
        }
        .float-right {
          float: right;
          margin-left: 15px;
        }
        &.last-td {
          text-align: right;
          padding-right: 40px;
        }
      }
    }
  }
`;
